import { createFileRoute, redirect } from "@tanstack/react-router";
export const Route = createFileRoute("/_dashboard/$datasetSlug/settings/custom-ui")({
  beforeLoad: ({ params }) => { throw redirect({ to: "/$datasetSlug/settings/plugins", params, replace: true }); },
});
